<template>
    <div class="textarea">
        <textarea
            v-model="currentValue"
            @keypress.13.prevent="$emit('submit')"
            :style="inputStyle"
            placeholder="Send a message..."
        />
        <textarea class="shadow" v-model="currentValue" ref="shadow" tabindex="0"/>
    </div>
</template>

<script>
export default {
    name: 'ChatInput',
    props: {
        value: String
    },
    data () {
        return {
            inputHeight: '0'
        }
    },
    computed: {
        inputStyle () {
            return {
                'min-height': this.inputHeight
            }
        },
        currentValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    mounted () {
        this.resize()
    },
    methods: {
        resize () {
            this.inputHeight = `${this.$refs.shadow.scrollHeight - 2}px`
        }
    },
    updated() {
        this.resize()
    },
}
</script>

<style lang="scss" scoped>

.textarea {
    pointer-events: initial;
    box-sizing: content-box;
    text-align: left;
    textarea {
        height: 0;
        width: calc(100% - 40px);

        font: inherit;
        font-weight: normal;
        font-size: inherit;
        color: white;
        padding: 15px;
        outline: none;
        border: none;
        border-radius: 8px;

        background-color: rgba(0,0,0,0.4);
        backdrop-filter: blur(20px);
        transition: all 0.2s ease;
        transition-property: min-height background-color color;
        resize: none;
        overflow: hidden;
        
        &::placeholder {
            color: rgba(255,255,255,0.7);
            font-weight: bold;
        }
        &:hover {
            background-color: rgba(255,255,255,0.6);
            color: black;
            &::placeholder {
                color: rgba(0,0,0,0.8);
            }
        }
        &:focus {
            background-color: white;
            color: black;
            &::placeholder {
                color: rgba(0,0,0,0.8);
            }
        }
        &.shadow {
            max-height: 0;
            pointer-events: none;
            opacity: 0;
            margin: 0;
            padding: 0;
        }
    }
}
    
</style>